// public/v3/src/lib/draft-helpers.js — pure helpers used by lib/draft.js.
//
// Lives separately from draft.js so that Jest can require it directly
// (draft.js uses ESM `import` for the React hook surface and can't be
// Jest-loaded). draft.js imports from this module via esbuild interop —
// same pattern as activity-log.js, workflow.js, and bhi-scales.js.
//
// Module format: CommonJS (module.exports). Pure functions only — no
// React, no fetches.
//
// Type-key convention for billing notes:
//   BHI keys start with 'bhi_' (e.g. 'bhi_bn', 'bhi_pcp_review').
//   CCM keys are everything else (e.g. 'bn_combined', 'bn_99490',
//   'bn_99491', 'bn_99487', 'bn_99439_1', …).
// `filterBnMapByProgram` partitions a billing-notes map by that convention
// so a single `/data/careplans` fetch can serve both programs without
// either contaminating the other's draft view.

function filterBnMapByProgram(bnMap, program) {
  if (!bnMap || typeof bnMap !== 'object') return {};
  const wantBhi = program === 'bhi';
  const out = {};
  for (const key of Object.keys(bnMap)) {
    const isBhiKey = typeof key === 'string' && key.startsWith('bhi_');
    if (wantBhi ? isBhiKey : !isBhiKey) {
      out[key] = bnMap[key];
    }
  }
  return out;
}

module.exports = {
  filterBnMapByProgram,
};
